/**
 * Contact Form Manager - Moon Moon Agency
 * Gestion des onglets pays (tablist ARIA) dans la card service client.
 */

/*********************************************************************************************
 * 🔧 CONTACT FORM MANAGER
 */
const ContactFormManager = {
	config: {
		selectors: {
			container: '[data-mm-contact-tabs]',
			tab: '[data-mm-contact-tab]',
			panel: '[data-mm-contact-panel]',
		},
		classes: {
			active: 'is-active',
		},
	},

	init() {
		const containers = window.getElements(this.config.selectors.container);
		if (!containers || containers.length === 0) return;

		containers.forEach((container) => this._bindContainer(container));
		window.log('info', '🔧 [CONTACT_FORM]', 'Initialized');
	},

	_bindContainer(container) {
		const tabs = container.querySelectorAll(this.config.selectors.tab);
		const panels = container.querySelectorAll(this.config.selectors.panel);
		if (tabs.length === 0) return;

		tabs.forEach((tab) => {
			tab.addEventListener('click', () => this._activate(tab, tabs, panels));
			tab.addEventListener('keydown', (e) => this._onKeydown(e, tab, tabs, panels));
		});
	},

	_activate(activeTab, tabs, panels) {
		const targetId = activeTab.getAttribute('aria-controls');

		tabs.forEach((tab) => {
			const isActive = tab === activeTab;
			tab.classList.toggle(this.config.classes.active, isActive);
			tab.setAttribute('aria-selected', String(isActive));
			tab.setAttribute('tabindex', isActive ? '0' : '-1');
		});

		panels.forEach((panel) => {
			const isActive = panel.id === targetId;
			panel.classList.toggle(this.config.classes.active, isActive);
			panel.hidden = !isActive;
		});
	},

	_onKeydown(e, currentTab, tabs, panels) {
		const tabsArray = Array.from(tabs);
		const currentIndex = tabsArray.indexOf(currentTab);
		let newIndex = null;

		if (e.key === 'ArrowRight') newIndex = (currentIndex + 1) % tabsArray.length;
		else if (e.key === 'ArrowLeft') newIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
		else if (e.key === 'Home') newIndex = 0;
		else if (e.key === 'End') newIndex = tabsArray.length - 1;

		if (newIndex === null) return;
		e.preventDefault();
		const newTab = tabsArray[newIndex];
		this._activate(newTab, tabs, panels);
		newTab.focus();
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => ContactFormManager.init());
} else {
	ContactFormManager.init();
}
